import MobileDashboardPage from './MobileDashboardPage';
export { MobileDashboardPage };
export default MobileDashboardPage;
